import type { RequiredAppSessionUser } from './required-app-session-user'
import { useAppSession } from '../contexts/AppSessionContext'
import { resolveRequiredAppSessionUser } from './required-app-session-user'
import { useResolvedAuthState } from './useResolvedAuthState'

export type { RequiredAppSessionUser } from './required-app-session-user'

/**
 * Use only inside components rendered behind the `protectedRoute === 'allow'` gate.
 * Throws if auth or backend user requirements are not satisfied.
 */
export function useRequiredAppSessionUser(): RequiredAppSessionUser {
  const { user } = useResolvedAuthState()
  const { backendUser, protectedRoute } = useAppSession()
  return resolveRequiredAppSessionUser({ protectedRoute, user, backendUser })
}
